export class Files {
    static moduleName = 'files';
    static listTitle = 'Справочник файлов';
    static createTitle = 'Добавление нового файла';
    static apiPrefix = '/files';
}